import validateSsp from './validateSsp';

export default {
  validateSsp,
};
